
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 19 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.916 7.69c-.108-.171-.162-.256-.192-.388a.928.928 0 010-.354c.03-.131.084-.217.192-.387.89-1.411 3.543-4.978 7.584-4.978 4.042 0 6.694 3.567 7.585 4.978.107.17.161.256.192.387a.927.927 0 010 .354c-.03.132-.085.217-.192.388-.891 1.41-3.543 4.977-7.585 4.977-4.041 0-6.693-3.566-7.584-4.977z","stroke":"inherit","stroke-width":"1.583","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.5 9.5a2.375 2.375 0 100-4.75 2.375 2.375 0 000 4.75z","stroke":"inherit","stroke-width":"1.583","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    